import { Check, X } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";

const paraTi = [
  "Buscas conversaciones auténticas y profundas.",
  "Quieres conocer a otras personas con altas capacidades.",
  "Estás dispuesto a escuchar y respetar experiencias diferentes.",
  "Quieres participar en un espacio sin juicios.",
  "Valoras la privacidad de los demás miembros.",
];

const noParaTi = [
  "Buscas un diagnóstico o tratamiento profesional.",
  "Quieres promocionarte, hacer spam o captar clientes.",
  "No respetas la confidencialidad.",
  "Utilizas ataques, discriminación o burlas.",
  "Esperas atención psicológica urgente o individual disponible las 24 horas.",
];

export const ParaQuien = () => (
  <section id="para-quien" className="bg-[#0E1628] px-5 py-24 md:py-32">
    <div className="mx-auto max-w-[1100px]">
      <ChapterLabel number="05" testId="chapter-para-quien" />
      <Reveal>
        <h2 className="max-w-3xl text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          Una comunidad pequeña, cuidada y con intención.
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Reveal className="h-full">
          <div
            data-testid="para-quien-si"
            className="h-full rounded-2xl border border-[#22304D] bg-[#131D33] p-8 md:p-10"
          >
            <h3 className="text-xl font-semibold tracking-tight text-[#F5F1EA] md:text-2xl">
              Es para ti si…
            </h3>
            <ul className="mt-7 space-y-4">
              {paraTi.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-400/10 text-emerald-400">
                    <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
                  </span>
                  <span className="text-sm leading-relaxed text-[#E8E4DC] md:text-base">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="h-full">
          <div
            data-testid="para-quien-no"
            className="h-full rounded-2xl border border-[#22304D] bg-[#131D33] p-8 md:p-10"
          >
            <h3 className="text-xl font-semibold tracking-tight text-[#F5F1EA] md:text-2xl">
              No es para ti si…
            </h3>
            <ul className="mt-7 space-y-4">
              {noParaTi.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-400/10 text-red-400">
                    <X className="h-3.5 w-3.5" strokeWidth={2.5} />
                  </span>
                  <span className="text-sm leading-relaxed text-[#9AA6BE] md:text-base">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
